import {Emitter} from '@wonderlandengine/api';
import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';
import {Player, PlayerStates} from './Player.js';
import {vec3} from 'gl-matrix';
import {AudioManager, globalAudioManager} from '@wonderlandengine/spatial-audio';
import {Sounds} from '../utils/Audio.js';
import {Weapon} from './combat/Weapon.js';

class GameState extends NotifyPropertyChanged {
    currentPlayer: Player;

    onShake: Emitter<[number, number]> = new Emitter();

    onAttack: Emitter<[number, vec3]> = new Emitter();

    onEnterShop: Emitter<[string, Weapon[]]> = new Emitter();

    onPause: Emitter<[]> = new Emitter();
    onResume: Emitter<[]> = new Emitter();

    storedVolume = 0;

    pause() {
        this.onPause.notify();

        globalAudioManager.stopAll();
    }

    resume() {
        this.onResume.notify();
    }

    constructor() {
        super();
    }

    init() {
        this.currentPlayer = new Player('Joe');
    }
    cameraShake(intensity: number = 0.2, duration: number = 0.07) {
        this.onShake.notify(intensity, duration);
    }

    gameOver() {
        globalAudioManager.playOneShot(Sounds.GameOver, {volume: 0.5});
        // implement game over logic
    }

    addAttackTextParticle(health: number, location: vec3) {
        if (
            gameState.currentPlayer.state === PlayerStates.Dead ||
            gameState.currentPlayer.state === PlayerStates.Dying
        ) {
            return;
        }

        this.onAttack.notify(health, location);
    }

    enterShop(merchantName: string, weapons: Weapon[]) {
        this.onEnterShop.notify(merchantName, weapons);
    }
}

export const gameState = new GameState();
